import { CheckAvailabilityUnlockProductQueryResult } from '../../../../../interfaces/schema';

export type ProductUnlockState = Omit<
  CheckAvailabilityUnlockProductQueryResult,
  '__typename'
>;

export const productUnlockKey = 'product-unlock';
export const productUnlockState: ProductUnlockState = {
  ANCESTRY: undefined,
  DNA_360: undefined,
  DNA_PREMIUM: undefined,
  NUTRIGENETIC: undefined,
  PRODIGY: undefined,
  SPORTGENOMIC: undefined
};
